module.exports = __webpack_public_path__ + "img/courses-international.d301b0aa.svg";